import AppRoutes from 'constants/AppRoutes';

export default {
  [AppRoutes.profile]: 'Profile',
  [AppRoutes.personalInfo]: 'Personal Info',
  [AppRoutes.clients]: 'Clients',
  [AppRoutes.companyInfo]: 'Company Info',
  [AppRoutes.multiLingual]: 'Multi-Lingual',
  [AppRoutes.companyAdmin]: 'Company Admin',
  [AppRoutes.uiConfiguration]: 'UI Configuration',
  [AppRoutes.moduleManagement]: 'Module Management',
  [AppRoutes.security]: 'Security',
  [AppRoutes.profilePassword]: 'Login & Security',
  [AppRoutes.profileSecurity]: 'Login & Security',
  [AppRoutes.launchpad]: 'Workflow hub',
  [AppRoutes.launchpadHub]: 'Workflow hub',
  [AppRoutes.launchpadSettings]: 'Settings',
  [AppRoutes.releaseHistory]: 'Release History',
  [AppRoutes.userManagement]: 'User Management',
  [AppRoutes.createNewUser]: 'Create New User',
  [AppRoutes.createUserPermissions]: 'Create New User',
  [AppRoutes.editUserInfo]: 'Edit User Info',
  [AppRoutes.editUserPermissions]: 'Edit User Info',
  [AppRoutes.clientUsers]: 'List of Users',
  [AppRoutes.clientUsersSecurity]: 'Edit User Info',
  [AppRoutes.companyUiConfiguration]: 'UI Configuration',
  [AppRoutes.balanceSheetAssets]: 'Data Sets Management',
  [AppRoutes.suppliers]: 'Data Sets Management',
  [AppRoutes.customers]: 'Data Sets Management',
  [AppRoutes.products]: 'Data Sets Management',
  [AppRoutes.profitCentres]: 'Data Sets Management',
  [AppRoutes.profitCentresCreate]: 'Create New Profit Centre',
  [AppRoutes.profitCentresEdit]: 'Edit Profit Centre',
  [AppRoutes.profileLanguage]: 'Language',
  [AppRoutes.balanceSheetAssetsCreate]: 'Add New Balance Sheet Asset',
  [AppRoutes.balanceSheetAssetsEdit]: 'Edit Balance Sheet Asset',
  [AppRoutes.supplierCreate]: 'Add New Supplier',
  [AppRoutes.supplierEdit]: 'Edit Supplier',
  [AppRoutes.productsCreate]: 'Add New Input Product',
  [AppRoutes.productsEdit]: 'Edit Input Product',
  [AppRoutes.customerCreate]: 'Add New Customer',
  [AppRoutes.customerEdit]: 'Edit Customer',
  [AppRoutes.taskManagement]: 'Task Management',
  [AppRoutes.taskManagementId]: 'Task Info',
  [AppRoutes.agentsManagement]: 'Agents Management',
  [AppRoutes.watchTower]: 'Watch Tower',
  [AppRoutes.watchTowerCompany]: 'Company',
  [AppRoutes.watchTowerImport]: 'Import',
  [AppRoutes.watchTowerSchedules]: 'Scheduler',
  [AppRoutes.watchTowerRuns]: 'Runs',
  [AppRoutes.watchTowerTopics]: 'Topics',
  [AppRoutes.watchTowerTopic]: 'Topic',
  [AppRoutes.marketingOps]: 'Marketing Ops',
  [AppRoutes.marketingOpsFinding]: 'Finding',
};
